import React from "react";
import styles from "./styles.module.css";

const ExpandText = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className={styles.expandText}>
      <input type="checkbox" id="expand-toggle" className={styles.expandToggle} />
      <div className={styles.content}>{children}</div>
      <label htmlFor="expand-toggle" className={styles.expandButton}>
        <span className={styles.moreText}>بیشتر بخوانید</span>
        <span className={styles.lessText}>بستن</span>
      </label>
    </div>
  );
};

export default ExpandText;